<template>
  <ul class="vt-dropdown"
      :class="{ 'vt-dropdown--disabled': off }"
      :name="name"
      ref="dropdown"
      tabindex="-1"
    >
    <li class="vt-dropdown__content" v-clickoutside="close">
      <button class="vt-dropdown__content-label" @click.prevent="open">
        <span class="vt-dropdown__content-label-text">
          {{ item.text }}
        </span>
        <span class="vt-dropdown__content-label-arrow">
          <svg><use xlink:href="#icon-arrow-down"/></svg>
        </span>
      </button>
      <ul ref="content" 
          class="vt-dropdown__content-items"
          :class="{ 'vt-dropdown__content-items--open': opened }"
        >
        <li class="vt-dropdown__content-items-item"
            :class="{ 'vt-dropdown__content-items-item--checked': item.text == placeholder }"
          >
          <button @mousedown.prevent="changeSelect(defaultItem)">{{ placeholder }}</button>
        </li>
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'
import uri from '../../../utils/uri'

export default {
  name: 'nt-select',
  props: {
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select',
    }
  },
  data() {
    return {
      opened: false,
      disabled: false,
      defaultItem: {
        text: this.placeholder,
        value: undefined,
      },
      item: {
        text: this.placeholder,
        value: undefined,
      }
    }
  },
  computed: {
    off() {
      return this.disabled
    }
  },
  updated() {
    this.disabled = !_.has(this.$slots, 'default')

    if (!_.has(uri.getQuery(), this.name)) {
      this.initialize(this.defaultItem)
    }
  },
  created() {
    this.$on('changeOption', this.changeSelect)
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.showIn()
    })
  },
  methods: {
    initialize(payload) {
      this.item = payload
    },
    changeSelect(payload) {
      if (payload.value !== this.item.value) {
        this.item = payload

        this.$emit('onchange', {
          name: this.name,
          value: payload.value
        })
      }
      this.close()
    },
    showIn() {
      if (!this.opened) return

      const { dropdown, content } = this.$refs

      const selectBounding = dropdown.getBoundingClientRect()
      const contentLimit = Math.abs(content.clientHeight / 2)

      const top = selectBounding.top
      const bottom = window.innerHeight - selectBounding.bottom

      if (top >= contentLimit && bottom >= contentLimit) {
        content.style.top = `-${contentLimit - (selectBounding.height / 2)}px`
      } else if (top >= contentLimit) {
        content.style.top = `-${content.clientHeight}px`
      } else {
        content.style.top = null
      }
    },
    open() {
      if (this.disabled) return

      this.opened = !this.opened

      this.$nextTick(() => {
        this.showIn()
      })
    },
    close() {
      // debugger
      this.opened = false
    }
  }
}
</script>

<style lang="scss">
ul, li {
  list-style: none;
  padding: 0;
  margin: 0;
  outline: 0;
}
.vt-dropdown {
  &--disabled {
    opacity: 0.3;
  }
  &__content {
    position: relative;
    &-label {
      display: flex;
      width: 100%;
      color: #e0dbd7;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding: 16px 26px;

      &:hover {
        cursor: pointer;
      }

      &-text {
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 90%;
      }
      &-arrow {
        box-sizing: border-box;
        height: 12px;
        width: 12px;
        position: relative;

        svg {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
        }
      }
    }
    &-items {
      position: absolute;
      z-index: 50;
      left: 0;
      right: 0;
      display: none;
      overflow: auto;
      background: #4e4e4e;
      // border: 1px solid #eee;
      max-height: 50vh;
      border: 1px solid #808080;
      box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.5);

      &::-webkit-scrollbar-track {
        // border: 1px solid #eee;
        padding: 2px 0;
        background-color: #999;
      }
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        // box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #1d2822;
        // border: 1px solid #ccc;
      }

      & > li:not(:last-of-type) {
        border-bottom: 1px solid #3b3b3b;
      }

      &--open {
        display: block;
      }
    }
  }
}
</style>
